<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";

export default {
  name: "GardenPlacesList",
  data() {
    return {
      loading: false,
      gardenPlaces: [],
      totalElements: 0,
      totalPages: null,
      size: 15,
      page: 1,

      selectedRegion: null,
      selectedDistrict: null,
      selectedQuarter: null,
      boards: [],
      regions: [],
      districts: [],
      quarters: [],
      districtsLoading: false,
      regionsLoading: false,

      // for files
      form: {
        board_id: null,
      },
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/garden-places/excel`,
      uploadHeader: {Authorization: `${this.$store.state.accessToken}`},

      rules: {
        board_id: [
          {
            required: true,
            message: "Tashabbuslar doskasini tanlang!",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
    },
  },
  methods: {
    onChangeBoard() {
      this.$router.replace({
        query: {
          ...this.$route.query,
          board: this.form.board_id,
        },
      });
      this.getGardenPlaces();
    },
    onChangeFilter(isRegion = false, isDistrict = false) {
      this.page = 1;
      if (isRegion) {
        this.districts = [];
        this.selectedDistrict = null;
        this.getDistricts();
      }

      if (isDistrict) {
        this.quarters = [];
        this.selectedQuarter = null;
        this.getQuarters();
      }

      this.$router.replace({
        query: {
          ...this.$route.query,
          region: this.selectedRegion,
          district: this.selectedDistrict,
          quarter: this.selectedQuarter,
        },
      });
      this.getGardenPlaces();
    },
    getBoards() {
      this.loading = true;
      this.$http
          .get(`api/v1/boards`, {
            params: {
              status: 1,
              type: 'MY_GARDEN'
            }
          })
          .then(({data}) => {
            this.form.board_id = this.$route.query.board
                ? parseInt(this.$route.query.board)
                : data.boards[0].id;
            this.boards = data.boards;
            this.getGardenPlaces();
          })
          .catch(() => {
            ElMessage.error(`Hatolik qayta urinib ko'ring`);
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
          .get("/api/v1/regions")
          .then(({data}) => {
            this.regions = data.regions;
          })
          .catch(() => {
          })
          .finally(() => {
            this.regionsLoading = false;
          });
    },
    getDistricts() {
      this.districtsLoading = true;
      this.$http
          .get("/api/v1/districts", {
            params: {
              region_id: this.selectedRegion,
            },
          })
          .then(({data}) => {
            this.districts = data.districts;
          })
          .catch(() => {
          })
          .finally(() => {
            this.districtsLoading = false;
          });
    },

    getQuarters() {
      if (!this.selectedDistrict) return;
      this.$http
          .get(`api/v1/quarters?district_id=${this.selectedDistrict}`)
          .then(({data}) => {
            this.quarters = data.quarters;
          })
          .catch((err) => {
            console.error("quarters fetch error", err);
          });
    },
    onClickDelete(id) {
      ElMessageBox.confirm("Ma'lumoitni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
          .then(() => {
            this.loading = true;
            this.$http
                .delete(`/api/v1/garden-places/${id}`)
                .then(() => {
                  ElMessage({
                    type: "success",
                    message: "Muvaffaqqiyatli o'chirildi",
                  });
                  this.getGardenPlaces();
                })
                .catch(() => {
                  ElNotification({
                    type: "error",
                    title: "Xatolik",
                    message: "Iltimos, qayta urinib ko'ring",
                  });
                })
                .finally(() => {
                  this.loading = false;
                });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "O'chirish bekor qilindi",
            });
          });
    },
    handleSizeChange(val) {
      this.page = 1;
      this.$router
          .replace({
            query: {...this.$route.query, size: val},
          })
          .then(() => {
            this.getGardenPlaces();
          })
          .catch(() => {
          });
    },
    handleCurrentChange(val) {
      this.$router
          .replace({
            query: {...this.$route.query, page: val},
          })
          .then(() => {
            this.getGardenPlaces();
          })
          .catch(() => {
          });
    },
    getGardenPlaces() {
      this.loading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.size = this.$route.query.size
          ? parseInt(this.$route.query.size || "")
          : this.size;
      this.$http
          .get(`api/v1/garden-places`, {
            params: {
              board_id: this.form.board_id,
              region_id: this.selectedRegion,
              district_id: this.selectedDistrict,
              quarter_id: this.selectedQuarter,
              limit: this.size,
              offset: (this.page - 1) * this.size,
            },
          })
          .then(({data}) => {
            this.gardenPlaces = data.data;
            this.totalElements = data.count;
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },

    onErrorUpload(error) {
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({name: "Auth"});
      }
      ElNotification({
        title: "Xatolik",
        message: "Ma'lumot yuklashda xatolik sodir bo'ldi!",
        type: "error",
      });
      this.loading = false;
    },
    onSuccessUpload() {
      this.loading = false;
      ElNotification.success({
        message: "Amaliyot muvaffaqiyatli bajarildi!",
      });
    },
    onBeforeUpload() {
      let isValid = this.$refs.formRef.validate((valid) => {
        this.loading = valid;
        return valid;
      });
      console.log("isValid", isValid);

      return isValid;
    },
    onExceed(files) {
      console.log("exceeds", files);
    },
    downloadExcel() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http
              .get(`api/v1/garden-places/excel`, {
                responseType: "blob",
                params: {
                  board_id: this.form.board_id,
                },
              })
              .then((res) => {
                const url = URL.createObjectURL(
                    new Blob([res.data], {
                      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                    })
                );
                const header = res.headers.get("Content-Disposition");
                const parts = header.split(";");
                let fileName = parts[1].split("=")[1];
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Ogohlantirish",
                  message:
                      response.data.message ||
                      "Ma'lumot yuklashda xatolik sodir bo'ldi!",
                  type: "warning",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      });
    },
  },
  mounted() {
    if (this.$route.query.board) {
      this.form.board_id = parseInt(this.$route.query.board);
    }
    if (this.$route.query.region) {
      this.selectedRegion = parseInt(this.$route.query.region);
      this.getDistricts();
    }
    if (this.$route.query.district) {
      this.selectedDistrict = parseInt(this.$route.query.district);
    }
    if (this.$route.query.quarter) {
      console.log("ssss");
      this.selectedQuarter = parseInt(this.$route.query.quarter);
      this.getQuarters();
    }

    this.getBoards();
    this.getRegions();
  },
};
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div class="filters">
        <el-select
            style="margin-right: 8px"
            v-model="form.board_id"
            @change="onChangeBoard"
        >
          <el-option
              v-for="board in boards"
              :key="board.id"
              :value="board.id"
              :label="
              board.title +
              ' ' +
              board.season +
              '-' +
              'mavsum ' +
              board.year +
              ' yil'
            "
          />
        </el-select>
        <el-select
            style="margin-right: 8px"
            v-model="selectedRegion"
            clearable
            @change="onChangeFilter(true)"
            placeholder="Viloyat"
        >
          <el-option
              v-for="region in regions"
              :value="region.id"
              :label="region.title"
              :key="region.id"
          ></el-option>
        </el-select>
        <el-select
            v-model="selectedDistrict"
            clearable
            @change="onChangeFilter(false, true)"
            placeholder="Tuman"
        >
          <el-option
              v-for="district in districts"
              :value="district.id"
              :label="district.title"
              :key="district.id"
          ></el-option>
        </el-select>
        <el-select
            placeholder="Mahalla"
            v-model="selectedQuarter"
            style="width: 100%"
            @change="onChangeFilter(false, false)"
        >
          <el-option
              v-for="quarter in quarters"
              :key="quarter.id"
              :value="quarter.id"
              :label="quarter.title"
          />
        </el-select>
      </div>
      <router-link to="garden-place/add" class="el-button el-button--primary">
        Qo'shish
      </router-link>
    </div>
    <el-form
        label-position="top"
        style="height: 40px"
        :model="form"
        :rules="rules"
        ref="formRef"
    >
      <div style="display: flex; align-items: center; justify-content: right">
        <el-form-item prop="file">
          <el-upload
              ref="uploadRef"
              class="upload-demo"
              :action="uploadUrl"
              :headers="uploadHeader"
              :data="form"
              :multiple="false"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              :limit="1"
              :on-exceed="onExceed"
              :before-upload="onBeforeUpload"
              :on-success="onSuccessUpload"
              :on-error="onErrorUpload"
          >
            <template #trigger>
              <el-button size="small" style="width: 100%" type="primary">
                Excel fayl orqali yangilash
              </el-button>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item style="margin-left: 8px">
          <el-button
              class="upload-demo"
              size="small"
              type="success"
              @click="downloadExcel"
          >
            <img
                style="margin-right: 10px"
                alt=""
                src="@/assets/images/icons/download.svg"
            />
            Mavjud bog' maydonlari ro'yxatini yuklab olish
          </el-button>
        </el-form-item>
      </div>
    </el-form>

    <el-table
        :data="gardenPlaces"
        class="table"
        border
        height="calc(100vh - 290px)"
    >
      <el-table-column type="index" :index="indexMethod" width="80"/>
      <el-table-column prop="owner" width="190" label="Egalik qiluvchi"/>
      <el-table-column prop="region" label="Viloyat" width="180"/>
      <el-table-column prop="district" label="Tuman" width="180"/>
      <el-table-column prop="quarter" label="Mahalla" width="180"/>
      <el-table-column prop="address" label="Manzil" width="180"/>
      <el-table-column prop="area" label="Maydon" width="180"/>
      <el-table-column prop="location" label="Lokatsiya" width="180"/>
      <el-table-column fixed="right" label="" width="200" align="center">
        <template #default="scope">
          <el-button
              type="primary"
              size="small"
              @click="
              $router.push({
                name: 'EditGardenPlace',
                params: { id: scope.row.id },
              })
            "
          >Tahrirlash
          </el-button>
          <el-button
              type="danger"
              size="small"
              @click="onClickDelete(scope.row.id)"
          >O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span>Jami: {{ totalElements }}</span>
          <el-pagination
              v-model:current-page="currentPage"
              class="pagination"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              layout="sizes, prev, pager, next"
              :total="totalElements"
              v-model:page-size="size"
              :page-count="totalPages"
              :background="true"
              :page-sizes="[15, 20, 30, 50, 100, 200, 500, 1000]"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;

  .actions {
  }
}

.el-button--primary {
  text-decoration: none;
}

:deep(.el-table .el-table__cell) {
  z-index: unset !important;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}

.pagination-wrapper > span {
  color: #0a194e;
  font-family: "Montserrat-Bold", sans-serif;
}

.download-button {
  height: 40px;
  width: 40px;
  border-radius: 8px;

  &:hover,
  &:focus {
    outline: none;
    box-shadow: none;
    border-color: var(--el-border-color);
    background-color: transparent;
  }
}

.filters {
  display: flex;
  gap: 5px;
  align-items: center;

  div {
    min-width: 200px;
  }
}

.upload-demo {
  display: flex;
  align-items: center;
}
</style>
